module.exports = __webpack_public_path__ + "img/edge_activites_trail.e0241dce.svg";